@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.bankilytransfers
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.dto.core.DateTimeDto
import com.narbase.letsgo.web.dto.drivers.DriverDto
import com.narbase.letsgo.web.models.TransferType

class BankilyTransferDto(
    val id: KmmLong?,
    val amount: Double?,
    val driverPhoneNumber: String?,
    val driverId: KmmLong?,
    val paymentId: KmmLong?,
    val transactionId: String?,
    val receivedOn: DateTimeDto,
    val createdOn: DateTimeDto,
    val message: String,
    @Suppress("NON_EXPORTABLE_TYPE") val type : DtoName<TransferType>
)

class ExtendedBankilyTransferDto(
    val bankilyTransfer: BankilyTransferDto,
    val driver: DriverDto?
)